import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkUpdateAdminRole,
    getAdminRoleUpdateProgress,
    stopAdminRoleUpdate,
} from 'src/openapi/admin/apis/BulkUpdateAdminRoleApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    ROLE_MODAL_TITLES,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    selectUpdateAdminRoleTask,
    selectUpdateAdminRoleUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from '../update-admin-role.slice';

import {UnassignFromRoleModal} from './unassign-from-role.modal';

import type {BulkUpdateAdminRoleRequest} from 'src/openapi/admin/models/BulkUpdateAdminRoleRequest';

type Props = {
    shown: boolean,
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UnassignFromRoleTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<BulkUpdateAdminRoleRequest>
            shown={shown}
            onClose={onClose}

            toolTask={TOOL_TASK}
            width={450}
            toolName={ROLE_MODAL_TITLES.UNASSIGN}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateAdminRoleTask}
            uuidSelector={selectUpdateAdminRoleUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(bulkUpdateAdminRoleRequest, options) => (
                apiDispatch(bulkUpdateAdminRole({...options, bulkUpdateAdminRoleRequest}))
            )}
            getProgress={id => apiDispatch(getAdminRoleUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopAdminRoleUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UnassignFromRoleModal {...{userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
